import React from "react";
import AuthLayout from "../components/AuthLayout";
import SignUpForm from "../components/SignUpForm";
import SuccessResponse from "../reusableComponents/components/generics/SuccessResponse";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PORTAL } from "../utils/constant";

function SuccessMessage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(PORTAL);
  };

  const handleBackButtonClick = () => {
    window.open(process.env.REACT_APP_IMS_URL);
  };
  return (
    <div>
      <AuthLayout
        imageTitle={t("titleCreateAccount")}
        imageSubtitle={t("subheadingCreateAccount")}
        buttonName={t("login")}
        accountMsg={t("alreadyAccount")}
        buttonClick={handleClick}
        backButtonClick={handleBackButtonClick}
      >
        <SuccessResponse
          title={t("signUpTitle")}
          message={t("signUpMsg")}
          handleClick={handleClick}
          ButtonName={t("login")}
        />
      </AuthLayout>
    </div>
  );
}

export default SuccessMessage;
